import type { ContentSummaryLink, AgentHitType } from '~/types/agent';

import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';

import styles from './styles.module.scss';

import { getSearchHitUrl } from '~/cmsagent/components/search-hit/utils';

interface HitsProps {
  links: ContentSummaryLink[];
  returnUrlText: string;
  returnUrl: string;
  onResultClick?: (title: string, hitType: AgentHitType) => void;
}

const Hits: React.FC<HitsProps> = props => {
  return (
    <div className={styles.hits}>
      {props.links.map(link => (
        <div key={link.url}>
          <p className={styles.hit__description}>{link.description}</p>
          <AnchorLink
            href={getSearchHitUrl(link.url, props.returnUrlText, props.returnUrl)}
            onClick={() => props.onResultClick?.(link.title, link.hitType)}
          >
            {link.title}
          </AnchorLink>
        </div>
      ))}
    </div>
  );
};

export default Hits;
